<template>
  <div>
    <yd-preview class="hotel" v-for="(hotel,index) in hotelList" :key="index" :buttons="[{
                        text: '我要订房',
                        link: {path: '/'+params.id + '/hotel-room/' + hotel.id}
                    }]">
      <yd-preview-header>
        <div class="head_name" slot="left">{{hotel.name}}</div>
        <div slot="right"></div>
      </yd-preview-header>
      <yd-preview-item style="min-height: 1.2rem;">
        <div slot="left" class="hotel_info">{{hotel.info}}</div>
        <div slot="right"></div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left" class="hotel_address">
          <div class="address"><img src="../../assets/image/dizhi.png" alt=""><span>{{hotel.address}}</span></div>
          <div class="phone"><img src="../../assets/image/dianhua.png" alt=""><span>{{hotel.telephone}}</span></div>
        </div>
        <div slot="right"></div>
      </yd-preview-item>
      <!-- <hr> -->
    </yd-preview>
    <img v-show="isCart" src="~assets/image/cart.png" id="cart" style="display: inline;" class="mescroll-totop2 mescroll-fade-in" @click="cart">
  </div>
</template>

<script type="text/babel">
import axios from 'axios'

export default {
  props: ['xuzhi'],
  data () {
    return {
      hotelList: [],
      isCart: false,
      params: this.$route.params
    }
  },
  methods: {
    getHotel () {
      let data = {fairid: this.params.id}
      axios
        .post('/hotel/hotel-list', data)
        .then(this.getHotelSucc)
    },
    getHotelSucc (res) {
      res = res.data
      if (res.status && res.datalist) {
        this.hotelList = res.datalist
      }
    },
    cart () {
      this.$router.push({path: '/' + this.params.id + '/room-buy'})
    },
    HistoryBack () {
      window.history.back()
    },
    getCart () {
      let dataf = {uid: this.$store.state.uid, fair_id: this.params.id}
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/hotel/request-book', dataf)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.isCart = true
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    }
  },
  mounted () {
    if (localStorage.ing !== '1') {
      this.$dialog.toast({
        mes: '报名已结束'
      })
      this.$router.push({path: '/' + this.params.id + '?code=' + this.$store.state.code})
      return false
    }
    if (!this.$store.state.token) {
      this.$router.push({path: 'single-my'})
    } else {
      if (localStorage.hotel_xuzhi) {
        this.$dialog.alert({mes: localStorage.hotel_xuzhi})
      }
      this.getCart()
      this.getHotel()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .mescroll-totop2
    z-index: 9990
    position: fixed
    right: 10px
    bottom: 250px
    width: 36px
    height: 36px
    border-radius: 50%
  .hotel
    width: calc(100% - .4rem)!important
    margin: 0 auto
    margin-top: .2rem
    margin-bottom: .2rem
    background-color: #fff
    border-radius: .2rem
  .yd-preview-header
    color: #333
    padding-right: 0
    margin-right: .24rem

  .yd-preview-item
    padding-bottom: 0
    display:block

  .yd-preview-item>:last-child
    text-align: right

  .yd-preview-header::after
    background-image: -webkit-gradient(linear,left bottom, left top,color-stop(50%, #ececec),color-stop(0, transparent));
  .hotel>:last-child
    padding-top: .2rem
  .hotel>:last-child::before
    display: none
  .hotel>:last-child>:last-child
    color: #fff
    background-color: #00C800
    margin: 0 auto
    border-radius: .06rem
    height: .8rem
  .hotel_info
    text-align: left!important
    margin-right: 0
    text-align-last: left!important
    overflow:hidden
    text-overflow:ellipsis
    display:-webkit-box
    -webkit-box-orient:vertical
    -webkit-line-clamp:3
    line-height: 1.2
  .hotel_address
    -moz-text-align-last: initial
    text-align-last: initial
    text-align: left
    line-height: .32rem
    position: relative

  .hotel_address img
    width: .32rem

  .hotel_address span
    padding-left: .1rem

  .phone
    position: relative
    margin-top: .1rem
    text-align: left

  .hotel>:nth-child(2)
    margin-bottom: .2rem
    padding-bottom: .2rem
    position: relative

  .hotel>:nth-child(2)::after
    content:""
    position: absolute
    height: 1px
    width: calc(100% - .48rem)
    background-image: -webkit-gradient(linear,left bottom, left top,color-stop(50%, #ececec),color-stop(0, transparent));
    bottom: 0
    left: .24rem

  .hotel_address>:last-child
    color: #999

  .head_name
    font-size 16px

  .yd-preview-item>:first-child
    margin-right 0

  .address
    padding-left: 0
    text-align: left
    
  .yd-preview-item>:first-child
    -moz-text-align-last: initial
    text-align-last: initial

</style>



// WEBPACK FOOTER //
// src/views/template1/HotelList.vue